export type Pack = "single" | "triple";
export type Mode = "portrait" | "scene" | "pet";

// Base prices for Portrait Mode.
const BASE: Record<Pack, number> = {
  single: 4.99,
  triple: 9.99,
};

// Full Scene Mode = Portrait + $2 per package.
const SCENE_DELTA = 2;

// Pet Mode has its own fixed pricing.
const PET: Record<Pack, number> = {
  single: 5.99,
  triple: 11.99,
};

export function getPriceNumber(pack: Pack, mode: Mode): number {
  if (mode === "pet") return PET[pack];
  if (mode === "scene") return BASE[pack] + SCENE_DELTA;
  return BASE[pack];
}

export function formatPrice(n: number): string {
  return `$${n.toFixed(2)}`;
}

export function getPrice(pack: Pack, mode: Mode): string {
  return formatPrice(getPriceNumber(pack, mode));
}

export const MODE_LABEL_KEY: Record<Mode, string> = {
  portrait: "mode.portrait",
  scene: "mode.scene",
  pet: "mode.pet",
};

export const MODE_DESC_KEY: Record<Mode, string> = {
  portrait: "mode.portraitDesc",
  scene: "mode.sceneDesc",
  pet: "mode.petDesc",
};
